import { UpdateMenuHeaderMetaForm } from "./UpdateMenuHeaderMetaForm";
import { getMenuHeaderDetails } from "@/sideEffects/api";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { ROUTES } from "@/constants/routeConstants";
import { useTranslation } from "react-i18next";
import { LoadingSmall } from "@/components/LoadingSmall";
import { DeleteMenuHeaderButton } from "./DeleteMenuHeaderButton";
import { BaseFormLayout } from "@/pages/shared/BaseFormLayout";

export const MenuHeaderDetailPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const menuHeaderId = searchParams.get("Id");

  const { data: menuHeaderDetails, isLoading } = useQuery({
    queryKey: ["getMenuHeaderDetails", menuHeaderId],
    queryFn: () => getMenuHeaderDetails(Number(menuHeaderId)),
  });

  const menuHeaderDetailsData = menuHeaderDetails?.data;

  useBreadcrumbs([
    {
      name: t("entities.menuHeader"),
      path: ROUTES.MENU_HEADER,
    },
    {
      name: menuHeaderDetailsData?.name ?? "...",
      path: ROUTES.MENU_HEADER_DETAIL,
    },
  ]);

  if (!menuHeaderDetailsData || isLoading) {
    return <LoadingSmall />;
  }

  return (
    <BaseFormLayout
      title={t("common.detail")}
      rightContent={<DeleteMenuHeaderButton menuHeaderId={menuHeaderDetailsData.id} />}
    >
      <UpdateMenuHeaderMetaForm menuHeaderDetails={menuHeaderDetailsData} />
    </BaseFormLayout>
  );
};
